module.exports={render:function (){with(this) {
  return _m(0)
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18a3c875!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-disqus/vue-disqus.vue
// module id = 45
// module chunks = 2